import * as types from "../../Action/actionTypes"

const initialState = {
  data: null,
  loading: false,
  error: null,
}

const onboardingReducer = (state = initialState, action) => {
  switch (action.type) {
    case types.ONBOARD_CREATOR_START:
    case types.ONBOARD_BRAND_START:
    case types.ONBOARD_AGENCY_START:
    case types.KYC_START:
      return {
        ...state,
        loading: true,
        error: null,
      }
    case types.ONBOARD_CREATOR_SUCCESS:
    case types.ONBOARD_BRAND_SUCCESS:
    case types.ONBOARD_AGENCY_SUCCESS:
    case types.KYC_SUCCESS:
      return {
        ...state,
        data: action.payload,
        loading: false,
        error: null,
      }
    case types.ONBOARD_CREATOR_ERROR:
    case types.ONBOARD_BRAND_ERROR:
    case types.ONBOARD_AGENCY_ERROR:
    case types.KYC_ERROR:
      return {
        ...state,
        loading: false,
        error: action.payload,
      }
    default:
      return state
  }
}

export default onboardingReducer
